<ul class="vertical-menu-list">
	<li class="vertical-menu-list__item">
		<app-accordeon
			[isOpen]="true"
			[view]="'classic'"
		>
			<ng-container title>Действия с полисом</ng-container>
			<div
				content
				class="action-with-card"
			>
				<ul class="action-with-card__list">
					<li class="action-with-card__list-item">
						<a
							class="button-text button-text--blacked action-with-card__list-link"
							(click)="openPdf()"
						>
							Посмотреть страховой полис
						</a>
					</li>
					<li class="action-with-card__list-item">
						<a
							class="button-text button-text--blacked action-with-card__list-link"
							(click)="openTooltip()"
						>
							Позвонить в АО "Русский Стандарт Страхование"
						</a>

						<app-tooltip-popup
							class="list-item__tooltip"
							[position]="'right'"
						>
							<a
								class="button-text button-text--blacked"
								href="tel:{{ detailInfo.insuranceCompanyPhoneNumber }}"
							>
								{{ detailInfo.insuranceCompanyPhoneNumber }}
							</a>
						</app-tooltip-popup>
					</li>
				</ul>
			</div>
		</app-accordeon>
	</li>
</ul>
